import { render, staticRenderFns } from "./veJkyProjectUser.vue?vue&type=template&id=354e9bfa&scoped=true"
import script from "./veJkyProjectUser.vue?vue&type=script&lang=js"
export * from "./veJkyProjectUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354e9bfa",
  null
  
)

export default component.exports